import { forwardRef, type TextareaHTMLAttributes } from 'react';

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

/**
 * Textarea estilizada, mismas tokens que TextInput. Default 3 rows.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ error, className, rows = 3, ...rest }, ref) {
    const classes = ['textarea'];
    if (className) classes.push(className);
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={classes.join(' ')}
        data-error={error ? 'true' : undefined}
        {...rest}
      />
    );
  },
);
